import { cva } from 'class-variance-authority';

export const base = cva(
  `
  appearance-none
  outline-none

  bg-foreground/2
  border

  checked:bg-outline

  disabled:opacity-60
  disabled:pointer-events-none

  transition-all
`,
  {
    variants: {
      error: {
        true: `
          border-error/50

          hover:border-error/50
          hover:ring-error

          focus:border-error/50
          focus:ring-error
          checked:bg-error
        `
      }
    }
  }
);

export const input = cva(
  [
    `
    appearance-none
    outline-none

    border
    border-primary/18
    rounded-xs

    w-full
    px-4
    py-[11px]
  
    bg-transparent
    text-primary

    shadow-none
  
    text-[16px]
    font-medium
  
    transition

    placeholder:text-[16px]/none
    placeholder:text-primary/40
    placeholder:antialiased
    placeholder:select-none

    hover:bg-primary/2

    focus:ring
    focus:border-accent
    focus:bg-primary/2

    [&:not(:placeholder-shown):not(:focus)]:bg-primary/2
    [&:not(:placeholder-shown):not(:focus)]:border-primary/32

    disabled:opacity-40
    disabled:pointer-events-none
    `
  ],
  {
    variants: {
      error: {
        true: `
          border-danger 
          focus:border-danger 
          [&:not(:placeholder-shown):not(:focus)]:border-danger
        `
      }
    }
  }
);
